export default "/dist/files/icon_participants.057f360aae7b4b877e64f8fbce9aa82e.svg";